/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_2_Item_0_TitleInputs */

const en_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game Teaching Professional`)
};

const es_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – profesional de la enseñanza`)
};

const de_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – Golflehrer`)
};

const zh_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game（推广高尔夫运动）教学专业人士`)
};

const ar_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game (نشر رياضة الغولف) – محترف تعليم`)
};

const fr_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – professionnel de l’enseignement`)
};

const vi_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – chuyên gia giảng dạy`)
};

const sw_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – mtaalamu wa kufundisha`)
};

const th_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game (การส่งเสริมกีฬากอล์ฟ) – มืออาชีพด้านการสอน`)
};

const bs_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – profesionalni učitelj golfa`)
};

const ja_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game（ゴルフ普及）ティーチングプロ`)
};

const ko_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game(골프 저변 확대) 티칭 프로`)
};

const pt_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – profissional de ensino`)
};

const it_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – professionista dell’insegnamento`)
};

const sv_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – undervisande golfprofessional`)
};

const nl_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – golfleraar`)
};

const da_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – undervisende golfprofessionel`)
};

const nb_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – undervisende golfprofesjonell`)
};

const fi_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game -opetusammattilainen`)
};

const pl_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – nauczyciel golfa`)
};

const ru_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game (развитие гольфа) – тренер-профессионал`)
};

const tr_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – eğitmen profesyonel`)
};

const hi_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game (गोल्फ़ का प्रसार) – शिक्षण प्रोफ़ेशनल`)
};

const id_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – profesional pengajar`)
};

const ms_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – profesional pengajaran`)
};

const cs_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – výukový profesionál`)
};

const el_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game (διάδοση του γκολφ) – επαγγελματίας διδασκαλίας`)
};

const he_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game (הפצת ענף הגולף) – מקצוען הוראה`)
};

const af_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – onderrigprofessional`)
};

const hu_about_content_honor_2_item_0_title = /** @type {(inputs: About_Content_Honor_2_Item_0_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAA Growth of the Game – oktató golfprofi`)
};

/**
* | output |
* | --- |
* | "GRAA Growth of the Game Teaching Professional" |
*
* @param {About_Content_Honor_2_Item_0_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_2_item_0_title = /** @type {((inputs?: About_Content_Honor_2_Item_0_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_2_Item_0_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_2_item_0_title(inputs)
	if (locale === "de") return de_about_content_honor_2_item_0_title(inputs)
	if (locale === "zh") return zh_about_content_honor_2_item_0_title(inputs)
	if (locale === "ar") return ar_about_content_honor_2_item_0_title(inputs)
	if (locale === "fr") return fr_about_content_honor_2_item_0_title(inputs)
	if (locale === "vi") return vi_about_content_honor_2_item_0_title(inputs)
	if (locale === "sw") return sw_about_content_honor_2_item_0_title(inputs)
	if (locale === "th") return th_about_content_honor_2_item_0_title(inputs)
	if (locale === "bs") return bs_about_content_honor_2_item_0_title(inputs)
	if (locale === "ja") return ja_about_content_honor_2_item_0_title(inputs)
	if (locale === "ko") return ko_about_content_honor_2_item_0_title(inputs)
	if (locale === "pt") return pt_about_content_honor_2_item_0_title(inputs)
	if (locale === "it") return it_about_content_honor_2_item_0_title(inputs)
	if (locale === "sv") return sv_about_content_honor_2_item_0_title(inputs)
	if (locale === "nl") return nl_about_content_honor_2_item_0_title(inputs)
	if (locale === "da") return da_about_content_honor_2_item_0_title(inputs)
	if (locale === "nb") return nb_about_content_honor_2_item_0_title(inputs)
	if (locale === "fi") return fi_about_content_honor_2_item_0_title(inputs)
	if (locale === "pl") return pl_about_content_honor_2_item_0_title(inputs)
	if (locale === "ru") return ru_about_content_honor_2_item_0_title(inputs)
	if (locale === "tr") return tr_about_content_honor_2_item_0_title(inputs)
	if (locale === "hi") return hi_about_content_honor_2_item_0_title(inputs)
	if (locale === "id") return id_about_content_honor_2_item_0_title(inputs)
	if (locale === "ms") return ms_about_content_honor_2_item_0_title(inputs)
	if (locale === "cs") return cs_about_content_honor_2_item_0_title(inputs)
	if (locale === "el") return el_about_content_honor_2_item_0_title(inputs)
	if (locale === "he") return he_about_content_honor_2_item_0_title(inputs)
	if (locale === "af") return af_about_content_honor_2_item_0_title(inputs)
	if (locale === "hu") return hu_about_content_honor_2_item_0_title(inputs)
	return en_about_content_honor_2_item_0_title(inputs)
});